import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import GenericTable from './UI/reusable-components/GenericTable';
import Product from './UI/reusable-components/Product';
import { fetchProducts } from '../redux/actions/productAction';
import productService from '../services/productService';
import categoryService from '../services/categoryService';
import { getMarketPlaces } from '../redux/actions/marketplacesActions';
import { getEcommercePlaces } from '../redux/actions/ecommercePlaceActions';
import axios from 'axios';

const productStates = [
  {
    value: 1,
    label: "Durum 1"
  },
  {
    value: 2,
    label: "Durum 2"
  },
  {
    value: 3,
    label: "Durum 3"
  },
]
export const Products = ({ setModel, model }) => {
  const dispatch = useDispatch();


  const [currentPage, setCurrentPage] = useState(1);


  const [pageSize, setPageSize] = useState(10);



  const [filtersValue, setFiltersValue] = useState(null);
  const authUserId = useSelector(state => state?.auth?.user?.id);
  const token = useSelector((state) => state?.auth?.user?.accessToken?.token);
  const [comboBoxFilter, setComboBoxFilter] = useState(null)
  const { products, filters, loading, error, totalProducts } = useSelector((state) => state.products);
  const [productsx, setProductsx] = React.useState([]);
  const [totalProductsx, setTotalProductsx] = React.useState([]);

  const [suppliers, setSuppliers] = React.useState([]);
  const [categories, setCategories] = React.useState([]);
  const [marketpleaces, setMarketpleaces] = React.useState([]);
  const [ecommerces, setEcommerces] = React.useState([]);

  const [isLoading, setIsLoading] = useState(false);

  const headers = ['Başlık', 'Fiyat Listesi', 'Stok', 'Kategori', 'Platform Yükleme Durumları', 'İşlemler'];
  const API_MARKETPLACES_URL = import.meta.env.VITE_API_URL;
  const [filterFields, setFilterFields] = useState([
    { label: "Ürün Adı", name: "title", type: "text", value: null },
    { label: "Ürün Barcode", name: "barcode", type: "text", value: null },
  ]);

  const comboBoxFilterFields = [
    { label: "Tedarikçiler", name: "SuplierId", options: suppliers },
    { label: "Kategori", name: "categoryId", options: categories },
    { label: "Pazaryeri Platformları", name: "transferMarketPlaceId", options: marketpleaces },
    { label: "Eticaret Platformları", name: "transferEcommercePlaceId", options: ecommerces },
  ];

  const rangeInputFilterFields = [];

  const fieldsToClear = {
    title: '',
    barcode: '',
    supplier: '',
    category: '',
    status: '',
  };

  const handleOnSearchFilters = async (filters) => {
    const model = comboBoxFilter != null ? comboBoxFilter : filters;
    setModel(model);
    setCurrentPage(1);
    await handlePageChangeFilter();

    // await fetchData(model) 
  }


  const fetchData = async (model) => {
    setIsLoading(true) 
    const response = await axios.get(`${API_MARKETPLACES_URL}/Product`, {
      params: {
        UserId: authUserId,
        Page: currentPage,
        PageSize: pageSize,
        WithCategory: true,
        WithProductAttribute: false,
        WithProductPlaces: true,
        WithBrand: false,
        WithProductBarcodes: true,
        WithProductImages: true,
        WithProductPriceHistories: false,
        WithProductPrices: false,
        WithProductStockHistories: false,
        WithPurchasePrices: false,
        ...model,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    setTotalProductsx(response.data.data.recordsTotal)
    setProductsx(response.data.data.data)

    setIsLoading(false)

  }

  useEffect(() => {
    handleOnSearchFilters()
  }, []);


  useEffect(() => {
    const fetchFilterOptions = async () => {
      try {
        // Tedarikçileri yükle

        const providerResponse = await productService.fetchProviders();
        const supplierOptions = providerResponse.map((provider) => ({
          value: provider.id,
          label: provider.name,
        }));

        setSuppliers(supplierOptions);

        // Kategorileri yükle
        const categoryResponse = await categoryService.getCategoriesApiForDropdown(null, 1, null, authUserId);
        const categoryOptions = categoryResponse.data.data.data.map((category) => ({
          value: category.id,
          label: category.name,
        }));

        setCategories(categoryOptions);



        // marketyerlerini yükle
        const markeresponse = await dispatch(getMarketPlaces(token));
        if (markeresponse.success) {
          const data = markeresponse?.data.map((x) => ({
            value: x.id,
            label: x.name,
          }));
          setMarketpleaces(data);
        }

        const ecommerceResponse = await dispatch(getEcommercePlaces(token));
        if (ecommerceResponse.success) {
          const data = ecommerceResponse?.data.map((x) => ({
            value: x.id,
            label: x.name,
          }));
          setEcommerces(data);
        }
      } catch (error) {
        console.error("Filtre seçenekleri yüklenirken hata oluştu:", error);
      }
    };

    fetchFilterOptions(); // Tedarikçi ve kategori bilgilerini yükle
  }, []);

  const handlePageChange = (newPage) => {
    const maxPage = Math.ceil(totalProductsx / pageSize);
    if (newPage >= 1 && newPage <= maxPage) {
      setCurrentPage(newPage);
    }
  };

  useEffect(() => { 
    if (currentPage) {
      const model = comboBoxFilter != null ? comboBoxFilter : filters;
      fetchData(model || {});
    }
  }, [currentPage, model,pageSize]);


  if (error) {
    return <div>Hata: {error}</div>;
  }
  return (
    <GenericTable
      data={productsx}
      headers={headers}
      filterFields={filterFields}
      setFilterFields={setFilterFields}
      filterLogic={(product, filters) => true}
      RowComponent={Product}
      filters={filters}
      comboBoxFilterFields={comboBoxFilterFields}
      fieldsToClear={fieldsToClear}
      rangeInputFilterFields={rangeInputFilterFields}
      setFiltersValue={setFiltersValue}
      onSearchFilters={handleOnSearchFilters}
      setComboBoxFilter={setComboBoxFilter}
      comboBoxFilter={comboBoxFilter}
      currentPage={currentPage}
      setCurrentPage={handlePageChange}
      pageSize={pageSize}
      setPageSize={setPageSize}
      totalItems={Number(totalProductsx) || 0}
      isLoading={isLoading || loading}
    />
  );
};
